<div class="flex flex-col gap-4 p-4">
  <h1 class="text-2xl leading-snug">Personenanzahl</h1>
  <div class="flex flex-col gap-4">
    <p>Für wie viele Personen möchten Sie reservieren?</p>
    <select (change)="setPersonCount($event)" class="p-4 bg-white rounded-lg border-[1px] border-benzGrey-900">
      <option value="" disabled selected>Bitte Anzahl Personen wählen</option>
      @for (option of personCountOptions(); track $index) {
        <option value="{{ option }}">{{ option }} Personen</option>
      }
    </select>
    <p>{{ progressService.selectedLodge()?.title_public }} kann Reservierungen in Vielfachen von
      @if (progressService.selectedLodge()!.table_factors.length > 1) {
        {{ progressService.selectedLodge()!.table_factors.slice(0, -1).join(", ") }} oder {{ progressService.selectedLodge()!.table_factors.slice(-1) }}
      } @else {
        {{ progressService.selectedLodge()!.table_factors.join(", ") }}
      }
      @if (progressService.selectedLodge()!.table_factors.length !== 1 || progressService.selectedLodge()!.table_factors[0] != 1) {
        Personen
      } @else {
        Person
      } entgegen nehmen.</p>
    @if (progressService.selectedPersons()) {
      <button routerLink="/booking/tokens" class="px-8 py-4 bg-benzRed-700 text-white rounded-lg">Für {{ progressService.selectedPersons() }}
        Personen reservieren
      </button>
    }
    <p>{{ progressService.selectedPackage()?.description }}</p>
  </div>
</div>
